<script setup>
import transitionConfig from '../../helpers/transitionConfig'
import generalFooterCtasJSON from 'assets/data/footerCtasGeneral.json'

const processedDataMenu = inject('processedDataMenu')
const internalMenuNav = getInternalNavMenu(processedDataMenu?.value, 'about')

definePageMeta({
  pageTransition: transitionConfig,
})

const {locale} = useI18n()
const parser = ParserUtils()

const config = useRuntimeConfig()

let endpoint = config.public.apiBase + locale.value + '/pages/team.json'
// console.log('ENDPOINT: ', endpoint)

const {fetchedData} = await useDataStatic(endpoint)

const processedData = computed(() => {
  if (fetchedData.value) {
    return parser.generalPage(fetchedData.value)
  }
  return null
})

const {injectScriptRecaptcha, deleteScriptRecaptcha} = useRecaptcha()

onMounted(() => {
  injectScriptRecaptcha()
  useAnimations()
})

onUnmounted(() => {
  deleteScriptRecaptcha()
})

useHead({
  title: () =>
    processedData.value?.section.title
      ? `${processedData.value?.section.title}`
      : '',
  meta: [
    {
      name: 'description',
      content: () => `${processedData.value?.section.description}`,
    },
  ],
  bodyAttrs: {
    class: 'page page--team',
  },
})

useSeoMeta({
  ogTitle: () => `${processedData.value?.section.seo.title}`,
  description: () => `${processedData.value?.section.seo.description}`,
  ogDescription: () => `${processedData.value?.section.seo.description}`,
  ogImage: () => `${processedData.value?.section.seo.image}`,
  twitterCard: 'summary_large_image',
})
</script>

<template>
  <div>
    <SharedModulesHero
      v-if="processedData"
      :content="processedData"
      :internalNav="internalMenuNav"
      internalNavCurrentPath="/about/team" />
    <div class="scroll-target" id="content"></div>
    <!-- <pre>{{ JSON.stringify(processedData, null, 2) }}</pre> -->
    <SharedMainContent :content="processedData" v-if="processedData" />
    <SharedModulesFooterCtas :content="generalFooterCtasJSON[locale]" />
    <ModalsPardotGeneral />
    <SharedContactButton :title="$t('floating_button.contact_us')" modal="modal:general" />
  </div>
</template>

<style lang="scss"></style>
